<template>
  <div class="categories-container">
    <transition-group name="list">
      <CategoryBlock
        v-for="category in categories"
        :key="category.id"
        :category="category"
      />
    </transition-group>
  </div>
</template>

<script>
import categories_nl_json from "../../public/items.json";
import categories_en_json from "../../public/items_en.json";
import categories_tr_json from "../../public/items_tr.json";
import CategoryBlock from "@/components/CategoryBlock.vue";

export default {
  name: "Categories",
  components: {
    CategoryBlock,
  },

  data() {
    return {
      items_files: {
        nl: categories_nl_json,
        en: categories_en_json,
        tr: categories_tr_json,
      },
      translations: {},
      categories: [],
      triggerCategories: 0,
    };
  },

  computed: {
    parents() {
      if (!this.$route.query.parent) return [];
      const parents = this.$route.query.parent.split(",").map(Number);
      return parents;
    },

    reactiveCategories() {
      // Should be executed if this.$route.query.lang or this.parents changes
      const react = this.$route.query.lang + this.parents.join(",");
      return react;
    },
  },

  watch: {
    reactiveCategories() {
      console.log("reactiveCategories");
      this.triggerCategories += 1;
    },
    triggerCategories() {
      console.log("triggerCategories");
      let items = JSON.parse(
        JSON.stringify(this.items_files[this.$route.query.lang])
      );
      console.log(items);
      if (this.parents.length > 0) {
        // Reach the subcategory by following the parents tree
        for (let i = 0; i < this.parents.length; i++) {
          items = items.find(
            (item) => item.id === this.parents[i]
          ).subCategories;
        }
      }

      this.categories = [];
      let index = 0;
      let intervalId = setInterval(() => {
        if (index < items.length) {
          this.categories.push(items[index]);
          index++;
        } else {
          clearInterval(intervalId);
        }
      }, 80); // delay in milliseconds
    },
  },

  created() {
    // this.categories = this.items_files[this.$route.query.lang];
  },

  mounted() {
    console.log("mounted");
    this.triggerCategories += 1;
    this.trigger += 1;
  },

  methods: {},
};
</script>

<style scoped>
.categories-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
}
.d-block {
  height: 250px; /* height of container */
  padding-top: 18%;
  object-fit: cover;
}

#nav {
  background-color: #354b7c;
}

.carousel-inner {
  margin-bottom: 10%;
}

.modal-body {
  padding: 0;
}

.modal-body img {
  max-width: 92vw;
}

.list-enter-active {
  -webkit-animation: puff-in-center 0.3s cubic-bezier(0.47, 0, 0.745, 0.715)
    both;
  animation: puff-in-center 0.3s cubic-bezier(0.47, 0, 0.745, 0.715) both;
}
.list-enter {
  -webkit-animation: puff-in-center 0.3s cubic-bezier(0.47, 0, 0.745, 0.715)
    both;
  animation: puff-in-center 0.3s cubic-bezier(0.47, 0, 0.745, 0.715) both;
}

@-webkit-keyframes puff-in-center {
  0% {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-filter: blur(4px);
    filter: blur(4px);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes puff-in-center {
  0% {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-filter: blur(4px);
    filter: blur(4px);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
</style>
